module.exports = __webpack_public_path__ + "img/icon-circle-twitter.0a4be92b.svg";